const addAuctionSearchHistory = function (that, data) {
  // 添加竞拍搜索历史记录
  if (data) {
    if (that.auctionSearchHistory.includes(data)) {
      // 数据中包含当前筛选数据-先删除，后从顶部添加
      that.auctionSearchHistory.splice(that.auctionSearchHistory.indexOf(data), 1);
    }
    // 搜索记录最多10条
    if (that.auctionSearchHistory.length >= 10) {
      that.auctionSearchHistory = that.auctionSearchHistory.slice(0, 9);
    }
    // 顶部添加数据
    that.auctionSearchHistory.unshift(data);
    sessionStorage.setItem('_auction_search_history_',that.auctionSearchHistory)
  }
}
const removeAuctionSearchHistory = function (that) {
  // 竞拍清除搜索缓存
  that.auctionSearchHistory = [];
  sessionStorage.removeItem("_auction_search_history_");
}

export {
  addAuctionSearchHistory,
  removeAuctionSearchHistory
}